
import ImageLoader from "@/assets/scripts/ImageLoader";
import {useRoute} from "vue-router";

export default {
  name: "PaymentMethodsTable",
  methods: {
    idealRedirect(orderID: string): void {
      const request = "https://api.rutsolve.com/rest/payments/ideal/" + orderID;
      fetch(request).then((response) => {
        if (response.status != 200) {
          console.error(response.statusText);
          return
        }
        response.text().then((url) => {
          window.location.replace(url);
        })
      })
    },
  },
  data() {
    return {
      idealLogo: ImageLoader.loadImageSrc("assets/images/logos/ideal.png") as string,
      orderID: useRoute().params.orderID.toString() as string,
    };
  },
};
